// Types.
import type { length } from '../../Types/Length';
import type { markerCallback } from '../../Types/Callbacks';
import type { state } from '../../Types/State';

// Constants.
import { states } from '../../Types/State';

// Interfaces.
import { MarkerOptions } from '../../Interfaces/Options';
import Progress from "../Progress";

// Methods.
import { toPx } from '../../Helpers/Helpers';

/**
 * Scrolly.Scene.Marker
 *
 * @author: FelixKiesewetter <info@felixkiesewetter.de>
 * @lastModified: 2025-09-05 Created.
 * @package felixkiesewetter-js/scroll
 * @version: 1.0.0
 */
class Marker
{

    private at            :length = '0%';
    private id            :string;
    private onStateChange :markerCallback;
    private state         :state = states.BEFORE;

    /**
     * Constructor.
     */
    constructor(options :MarkerOptions)
    {
        this.setAt(options.at);
        this.setOnStateChange(options.onStateChange);
        this.setId(options.id);
    }

    // ##############
    // Public methods
    // ##############

    /**
     * Run the onStateChange callback function.
     */
    public callOnStateChange() :void
    {
        return this.onStateChange({
            id: this.id.toString(),
            state: this.state
        });
    }

    /**
     * Check if the marker has changed its state.
     */
    public changedState(progress :Progress) :boolean
    {
        const passed :boolean = toPx(this.at, progress.getLength()) < progress.getDistance();
        if (passed && states.AFTER !== this.state) {
            this.setState(states.AFTER);
            return true;
        }
        else if (!passed && states.BEFORE !== this.state) {
            this.setState(states.BEFORE);
            return true;
        }
        return false;
    }

    // #######
    // Getters
    // #######

    // ...

    // #######
    // Setters
    // #######

    /**
     * Setter for the marker position.
     */
    public setAt(at :length) :Marker
    {
        this.at = at;
        return this;
    }

    /**
     * Setter for the callback function.
     */
    public setOnStateChange(onStateChange :markerCallback) :Marker
    {
        this.onStateChange = onStateChange;
        return this;
    }

    /**
     * Setter for the id.
     */
    private setId(id :string) :Marker
    {
        this.id = id;
        return this;
    }

    /**
     * Setter for the marker's current state.
     */
    private setState(state :state) :Marker
    {
        this.state = state;
        return this;
    }

    // ##############
    // Static methods
    // ##############

    static create(options :MarkerOptions) :Marker
    {
        return new Marker(options);
    }

}

export default Marker;